export enum HighCommissionBoosting {
  NAME = 'plp_hc_boosting',
  OFF = 'off',
  ON = 'on',
}

export enum Facets {
  DYNAMIC = 'dynamic',
  NAME = 'plp_facets',
  STATIC = 'static',
}
